<template>
  <div class="baseResult">
    <viewHeader></viewHeader>
    <div class="content">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <img src="../assets/img/icon0.png" alt="" class="L" />
          <span class="L">{{ title_word }}</span>
          <el-button
            class="R"
            style="padding: 3px 0"
            type="text"
            @click="analysis"
            >文献总结</el-button
          >
        </div>
        <div class="resultTtle">
          <p
            class="pointData el-icon-warning-outline"
            v-if="preNumFound === 0 && totalNum !== 0"
          >
            未找到匹配的文献，推荐您阅读以下相关文献
          </p>
          <el-row :gutter="60">
            <el-col :span="5" class="num"
              >共为您找到<span>{{ totalNum }}</span
              >篇文献</el-col
            >
            <el-col :span="19">
              <el-col :span="4" style="cursor: pointer; padding: 0">
                <el-dropdown trigger="click" @command="handleCommand($event,true)">
                  <span class="el-dropdown-link">
                    文献类型<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in pubType"
                      :key="index"
                      :command="{ value: item, name: 'pubType' }"
                      >{{ item }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <el-col :span="4" style="cursor: pointer; padding: 0">
                <el-dropdown
                  trigger="click"
                  style="cursor: pointer"
                  @command="handleCommand($event,false)"
                >
                  <span class="el-dropdown-link">
                    发表时间<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in pubDate"
                      :key="index"
                      :command="{ value: item, name: 'pubDate' }"
                    >
                      <span v-if="item === '全部'">{{ item }}</span>
                      <span v-else-if="item !== '全部'">近{{ item }}年</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <el-col :span="4" style="cursor: pointer; padding: 0">
                <el-dropdown
                  trigger="click"
                  style="cursor: pointer"
                  @command="handleCommand($event,true)"
                >
                  <span class="el-dropdown-link">
                    影响因子<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in impFct"
                      :key="index"
                      :command="{ value: item, name: 'impFct' }"
                      >{{ item }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <el-col
                :span="7"
                class="clearfix"
                style="cursor: pointer; margin-top: -4px; padding: 0"
              >
                <!-- <el-dropdown trigger="click" @command="handleCommandSort">
                                    <span class="el-dropdown-link">
                                        相关性排序<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item, index) in sort" :key="index" :command="{ 'value': item, 'name': 'sort' }">{{ item }}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown> -->
                <span class="L sort_sp">排序</span>
                <el-select
                  v-model="sortText"
                  placeholder="请选择"
                  size="small"
                  @change="handleCommandSort"
                  class="L"
                >
                  <el-option
                    v-for="(item, index) in sort"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <!-- <el-col :span="4" class="R">
                                <el-checkbox v-model="manual" @change="change">只看人工标注</el-checkbox>
                            </el-col> -->
            </el-col>
          </el-row>
        </div>
        <div class="tags">
          <el-row>
            <el-col :span="20">
              <el-tag
                closable
                v-for="(tag, tagIndex) in tags"
                :key="tagIndex"
                @close="closeTags(tag, tagIndex)"
              >
                {{ tag }}
              </el-tag>
            </el-col>
            <el-col
              :span="4"
              class="clearfix clearBtn"
              v-if="tags.length !== 0"
            >
              <el-link type="primary" class="R" @click="clearFilter"
                >清空筛选条件</el-link
              >
              <img src="../assets/img/clear.png" alt="" class="R" />
            </el-col>
          </el-row>
        </div>
        <div
          class="resultList"
          v-loading.fullscreen="loading"
          element-loading-text="拼命加载中"
          v-show="hasData"
        >
          <ul>
            <li
              v-for="(item, index) in searchData"
              :key="index"
              v-loading="item.loading"
            >
              <el-row :gutter="20" class="listTitle">
                <el-col :span="14" class="title">
                  {{ item.title_en }}
                  <img v-show="item.is_download && isVip == 2" class="pptIcon" src="../assets/img/ppt.png" alt="">
                </el-col>
                <el-col
                  :span="5"
                  class="YXYZ clearfix"
                  v-if="item.impact_factor && item.impact_factor !== ''"
                >
                  <img src="../assets/img/icon6.png" alt="" class="L" />
                  <span class="L">影响因子：{{ item.impact_factor }}</span>
                </el-col>
                <el-col
                  :span="5"
                  class="RGBZ clearfix"
                  v-if="item.has_manual_curation !== 0"
                >
                  <img src="../assets/img/icon5.png" alt="" class="L" />
                  <span class="L"
                    >人工标注：{{ item.has_manual_curation }}</span
                  >
                </el-col>
              </el-row>
              <div class="tags">
                <articleTags :pubdate="item.pubdate_show" :language="item.language" :pubType="item.pub_type"></articleTags>
              </div>
              <el-row class="listInfo">
                <el-col :span="10"><span>PMID：</span>{{ item.pmid }}</el-col>
                <el-col :span="10" v-if="item.doi"><span>DOI：</span>{{ item.doi }}</el-col>
                <el-col :span="20"
                  ><span>期刊：</span>{{ item.journal_name }}</el-col
                >
                <!-- <el-col :span="20"
                  ><span>发表时间：</span>{{ item.pubdate_show }}</el-col
                > -->
                <el-col
                  :span="20"
                  v-if="
                    item.keyword_categories != null &&
                    item.keyword_categories['Diseases']
                  "
                >
                  <span>疾病：</span>
                  <em
                    v-for="(disease, disIndex) in item.keyword_categories[
                      'Diseases'
                    ]"
                    :key="disIndex"
                    >{{ disease[0] + "(" + disease[1] + ")"
                    }}<i
                      v-if="
                        disIndex + 1 <
                        item.keyword_categories['Diseases'].length
                      "
                    >
                      、</i
                    ></em
                  >
                </el-col>
                <el-col
                  :span="20"
                  v-if="
                    item.keyword_categories != null &&
                    item.keyword_categories['Drugs and Chemicals']
                  "
                >
                  <span>药品：</span>
                  <em
                    v-for="(drug, drugIndex) in item.keyword_categories[
                      'Drugs and Chemicals'
                    ]"
                    :key="drugIndex"
                    >{{ drug[0] + "(" + drug[1] + ")"
                    }}<i
                      v-if="
                        drugIndex + 1 <
                        item.keyword_categories['Drugs and Chemicals'].length
                      "
                    >
                      、</i
                    ></em
                  >
                </el-col>
                <el-col
                  :span="20"
                  v-if="
                    item.keyword_categories != null &&
                    item.keyword_categories['Geographic Locations']
                  "
                >
                  <span>地理位置：</span>
                  <em
                    v-for="(location, locationIndex) in item.keyword_categories[
                      'Geographic Locations'
                    ]"
                    :key="locationIndex"
                    >{{ location[0] + "(" + location[1] + ")"
                    }}<i
                      v-if="
                        locationIndex + 1 <
                        item.keyword_categories['Geographic Locations'].length
                      "
                    >
                      、</i
                    ></em
                  >
                </el-col>
                <!-- 隐藏研究背景，研究目的，研究结论 添加important_message字段 2021-01-05 qinrui-->
                <!-- <el-col :span="20" v-if="item.key_information"> -->
                <el-col :span="20" v-if="item.important_message && item.important_message.length != 0 && isVip == 2">
                  <span>重点信息：</span>
                  <div>
                    <p class="key_infor" v-for="(important, importantIndex) in item.important_message" :key="'重点信息' + importantIndex">
                      {{ `● ${important}` }}
                    </p>
                    <!-- <p
                      class="key_infor"
                      v-if="
                        item.key_information[0] &&
                        item.key_information[0][1] !== ''
                      "
                    >
                      <span>研究背景：</span>{{ item.key_information[0][1] }}
                    </p>
                    <p
                      class="key_infor"
                      v-if="
                        item.key_information[1] &&
                        item.key_information[1][1] !== ''
                      "
                    >
                      <span>研究目的：</span>{{ item.key_information[1][1] }}
                    </p>
                    <p
                      class="key_infor"
                      v-if="
                        item.key_information[4] &&
                        item.key_information[4][1] !== ''
                      "
                    >
                      <span>研究结论：</span>{{ item.key_information[4][1] }}
                    </p> -->
                  </div>
                  <!-- <em
                    class="R down"
                    :class="
                      item.key_height === 'initHeight'
                        ? 'el-icon-arrow-down'
                        : 'el-icon-arrow-up'
                    "
                    @click="showFull(item.key_height, index)"
                  ></em> -->
                  <!-- <button class="R down" @click="showFull(item.key_height, index)">{{ item.key_height === 'initHeight' ? '展开' : '收起'}}</button> -->
                </el-col>
                <el-col :span="20" v-if="item.abstract_en">
                  <div :class="item.key_height">
                    <p class="key_infor">
                      <span>文献摘要：</span>
                      <em
                        style="margin-top: 10px"
                        v-for="(abstract, abstractIndex) in item.abstract_en" :key="'abstract' + abstractIndex">{{ abstract }}</em>
                    </p>
                  </div>
                  <em
                    class="R down"
                    :class="
                      item.key_height === 'initHeight'
                        ? 'el-icon-arrow-down'
                        : 'el-icon-arrow-up'
                    "
                    @click="showFull(item.key_height, index)"
                  ></em>
                </el-col>
              </el-row>
              <div class="action">
                <a
                  href="javascript:;"
                  class="translate"
                  @click="translateKey(item.pmid, index, item.translate)"
                  title="翻译"
                >
                  <!-- <img src="../assets/img/icon1.png" alt="" class="translate"> -->
                </a>
                <a
                  href="javascript:;"
                  class="fullText"
                  title="查看全文"
                  @click="showFullText(item.pmid)"
                >
                  <!-- <img src="../assets/img/icon2.png" alt="" class="fullText"> -->
                </a>
                <a
                  href="javascript:;"
                  :class="item.is_collected ? 'collectionTrue' : 'collection'"
                  title="收藏"
                  @click="collection(item.pmid, item.is_collected, index)"
                >
                  <!-- <img src="../assets/img/icon3.png" alt="" class="collection"> -->
                </a>
                <!-- <a href="javascript:;" class="share" title="分享"> -->
                <!-- <img src="../assets/img/icon4.png" alt="" class="share"> -->
                <!-- </a> -->
              </div>
            </li>
          </ul>
        </div>
        <el-pagination
          v-show="isShow"
          background
          :hide-on-single-page="true"
          :current-page="pageNum"
          :page-size="pageSize"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="totalNum"
        >
        </el-pagination>
      </el-card>
      <div class="noData" v-show="!hasData">
        <img src="../assets/img/empty.png" alt="" />
        <span>空空如也，重新搜搜看看吧~</span>
      </div>
    </div>
  </div>
</template>

<script>
import { md5 } from "md5js";
import viewHeader from "./viewHeader";
import articleTags from '../components/articleTags.vue'
import dayjs from 'dayjs'
import {
  normalSearch,
  getFilters,
  translateInfo,
  collection,
  advancedSearch,
  getRole,
  getUserVip
} from "../service/getData";
import { webTrackerEvent } from "../utils/tracker";
export default {
  name: "baseResult",
  components: {
    viewHeader,
    articleTags
  },
  data() {
    return {
      hasData: true, // 是否有数据
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154",
      clientId: "zeta",
      loading: true, // 页面加载动画
      keyword: "", // 搜索的关键字
      searchData: [], // 搜索出的文献数据
      pageNum: 1, // 当前页
      pageSize: 10, // 每页数量
      totalNum: 0, // 搜索出的总数
      isShow: false,
      pubType: [], // 文献类型
      pubDate: [], // 发表时间
      impFct: [], // 影响因子
      sort: [], // 相关性排序
      manual: false, // 是否是人工标注
      filter: {
        pubType: [],
        pubDate: [],
        impFct: [],
        manual: "",
      }, // 筛选条件
      sortText: "相关性从高到低",
      titleJson: {},
      abstractJson: {},
      importantJson: {}, // 重点信息
      // advance: false, // 是否是精准搜索
      tags: [], // 过滤条件
      tagsJson: {},
      preNumFound: 1, //如果为0，提示用户没找到相关文献，并推荐其他文献
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      isVip:undefined,
      searchType: ''
    };
  },
  methods: {
    // 获取基本搜索的文献结果
    async normalSearch() {
      const params = {
        keyword: this.keyword,
        pages: { limit: this.pageSize, page: this.pageNum },
        filters: {
          manual: this.filter.manual,
          pubType: this.filter.pubType.join('|'),
          impFct: this.filter.impFct.join('|'),
          pubDate: this.filter.pubDate[0] || ''
        },
        sort: this.sortText,
      };
      let Logger = webTrackerEvent();
      let res = "";
      if (this.searchType === "advanced") {
        Logger.push("search_type", "precise");
        res = await advancedSearch(params);
      } else {
        Logger.push("search_type", "normal");
        res = await normalSearch(params);
      }
      Logger.push("search_kind", "normal");
      Logger.push("page_url", window.location.href);
      Logger.push("action", "search");
      Logger.push("search_keyword", this.keyword);
      Logger.push("search_filter", JSON.stringify(this.filter));
      Logger.push("search_sort", this.sortText);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res && res.data.status === 0) {
        this.isShow = true;
        this.loading = false;
        this.totalNum = res.data.numFound;
        this.preNumFound = res.data.pre_numFound;
        if (res.data.data.length === 0) {
          this.hasData = false;
          return;
        }
        this.hasData = true;
        res.data.data.forEach((item, index) => {
          if (item.pubdate_show) {
            // item.pubdate_show = item.pubdate_show.substring(0, 10);
            item.loading = false;
          }
          item.key_height = "initHeight";
          item.translate = false;
          item.abstract_en = item.abstract_en.split('\n');
          this.abstractJson[index] = item.abstract_en;
          this.titleJson[index] = item.title_en;
          this.importantJson[index] = item.important_message;
        });
        this.searchData = res.data.data;
      } else {
        this.isShow = true;
        this.loading = false;
        this.hasData = false;
      }
    },
    // 获取筛选条件
    async getFilterOpt() {
      const res = await getFilters();
      if (res && res.data.status === 0) {
        this.pubType = ["全部", ...res.data.data.pubType];
        this.pubDate = ["全部", ...res.data.data.pubDate];
        this.impFct = ["全部", ...res.data.data.impFct];
        this.sort = res.data.data.sort;
      }
    },
    // 筛选条件
    handleCommand(command,multiple) {
      const {value,name} = command;
      const selectedList = this.tagsJson[name];
      
      if(selectedList) {
        const isExist = selectedList.find(item => item == value);
        if(isExist) {
          return;
        }
      } else if(value == '全部') {
        return;
      }

      
      // 修改过滤条件
      if (command.value === "全部") {
        this.filter[command.name] = [];
      } else {
        if(multiple) {
          this.filter[command.name].push(command.value);
        } else {
          this.filter[command.name] =  [command.value];
        }
      }

      // 获取过滤条件 标签显示
      if (command.name === "pubDate") {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push("近" + command.value + "年") : this.tagsJson[command.name] = ["近" + command.value + "年"];
          } else {
            this.tagsJson[command.name] = ["近" + command.value + "年"];
          }
        } else {
          delete this.tagsJson["pubDate"];
        }
      } else {
        if (command.value !== "全部") {
          if(multiple) {
            this.tagsJson[command.name] ? this.tagsJson[command.name].push(command.value) : this.tagsJson[command.name] = [command.value];
          } else {
            this.tagsJson[command.name] = [command.value];
          }
        } else {
          delete this.tagsJson[command.name];
        }
      }
      this.tags = [];
      for (const name in this.tagsJson) {
        this.tags.push(...this.tagsJson[name]);
      }
      this.showTags = true;
      // this.isShow = false
      this.loading = true;
      // this.searchData = []
      this.pageNum = 1;
      this.normalSearch();
    },
    // 关闭标签
    closeTags(tag, tagIndex) {
      for (const name in this.tagsJson) {
        const selectedList = this.tagsJson[name];
        const index = selectedList.findIndex(item => item == tag);
        
        if(index > -1) {
          selectedList.splice(index,1);
          const filterIndex = this.filter[name].findIndex(item => {
            if(name == 'pubDate') {
              return `近${item}年` == tag;
            } else {
              return item == tag;
            }
          });
          if(filterIndex > -1) {
            this.filter[name].splice(filterIndex,1);
          }
          break;
        }
      }
      this.tags.splice(tagIndex, 1);
      if (this.tags.length === 0) {
        this.tagsJson = {};
      }
      this.loading = true;
      this.pageNum = 1;
      this.normalSearch();
    },
    // 清除筛选条件
    clearFilter() {
      this.tags = [];
      this.tagsJson = {};
      this.filter["pubType"] = [];
      this.filter["pubDate"] = [];
      this.filter["impFct"] = [];
      this.loading = true;
      this.pageNum = 1;
      this.normalSearch();
    },
    // 排序条件
    handleCommandSort(val) {
      this.loading = true;
      // this.searchData = []
      this.pageNum = 1;
      this.normalSearch();
    },
    // 选择人工标注
    change(val) {
      if (val) {
        this.filter["manual"] = 1;
      } else {
        this.filter["manual"] = "";
      }
      // this.isShow = false
      this.loading = true;
      // this.searchData = []
      this.pageNum = 1;
      this.normalSearch();
    },
    // 翻译重点信息
    async translateKey(pmid, index, translate) {
      this.searchData[index].loading = true;
      let key_type = "";
      if (translate) {
        this.searchData[index].title_en = this.titleJson[index];
        this.searchData[index].abstract_en = this.abstractJson[index];
        this.searchData[index].important_message = this.importantJson[index];
        key_type = "en_key";
      } else {
        key_type = "cn_key";
      }
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${pmid}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(pmid),
        types: key_type,
        token: token,
      };
      const res = await translateInfo(params);

      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "translate");
      Logger.push("language", key_type);
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status == 0) {
        if (!translate) {
          this.searchData[index].title_en = res.data.data.title;
          this.searchData[index].key_information = res.data.data.sentence;
          this.searchData[index].important_message = res.data.data.important_message;
          // this.searchData[index].translate = true;
          // this.searchData[index].loading = false;
          this.translateFullText(pmid, index);
          return;
        }
        this.searchData[index].key_information = res.data.data.sentence;
        this.searchData[index].translate = false;
        this.searchData[index].loading = false;
      }
    },
    // 翻译摘要（全文）
    async translateFullText(pmid, index) {
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${pmid}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(pmid),
        types: "cn_full",
        token: token,
      };
      const res = await translateInfo(params);
      if (res.data.status == 0) {
        this.searchData[index].abstract_en = res.data.data.sentence;
        this.searchData[index].translate = true;
        this.searchData[index].loading = false;
      }
    },
    // 展开全文
    showFull(key_height, index) {
      if (key_height === "initHeight") {
        this.searchData[index]["key_height"] = "autoHeight";
      } else {
        this.searchData[index]["key_height"] = "initHeight";
      }
    },
    // 收藏还是取消收藏
    collection(pmid, collect, index) {
      if (!collect) {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "collection");
        Logger.push("pmid", pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        collection("POST", { pmid: pmid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = true;
          } else {
            this.$message({
              message: "收藏失败，请重试",
              type: "error",
            });
          }
        });
      } else {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "delete_collection");
        Logger.push("pmid", pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        collection("DELETE", { pmid: pmid }).then((res) => {
          if (res.data.status === 0) {
            this.searchData[index].is_collected = false;
          } else {
            this.$message({
              message: "取消失败，请重试",
              type: "error",
            });
          }
        });
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.loading = true;
      // this.isShow = false
      // this.searchData = []
      this.pageNum = val;
      window.scroll(0, 0);
      this.normalSearch();
    },
    // 查看全文
    showFullText(pmid) {
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "fullText");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "fullText",
        path: "/fullText",
        query: {
          pmid: pmid
        },
      });
      window.open(href);
      // this.$router.push("fullText?pmid=" + pmid);
    },
    // 文献总结
    analysis() {
      let Logger = webTrackerEvent();
      Logger.push("search_type", "normal");
      let searchType = "normal";
      if (this.searchType && this.searchType === "advanced") {
        searchType = "advanced";
        Logger.push("search_type", "precise");
      }
      const { href } = this.$router.resolve({
        name: "pubMedChart",
        path: "/pubMedChart",
        query: {
          key: this.keyword,
          numFound: this.totalNum,
          filter: JSON.stringify({
            manual: this.filter.manual,
            pubType: this.filter.pubType.join('|'),
            impFct: this.filter.impFct.join('|'),
            pubDate: this.filter.pubDate[0] || ''
          }),
          sort: this.sortText,
          searchType: searchType,
        },
      });
      Logger.push("search_kind", "normal");
      Logger.push("page_url", window.location.href);
      Logger.push("action", "pubMedChart");
      Logger.push("search_keyword", this.keyword);
      Logger.push("search_filter", JSON.stringify(this.filter));
      Logger.push("search_sort", this.sortText);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      window.open(href);
    },
    // 获取用户角色
    async getUserRole() {
      const res = await getRole();
      if (res && res.data.status === 0) {
        // this.isVip = Number(res.data.data["is_vip"]);
        // window.localStorage.setItem("ISVIP", res.data.data["is_vip"]);
        window.localStorage.setItem("ISADMIN", res.data.data["is_admin"]);
        window.localStorage.setItem("ISEDITOR", res.data.data["is_editor"]);
      }
    },
    /**
     * 获取个人vip等级
     */
    async handleGetVip(){
      let res = await getUserVip();
      let {status,data} = res.data;
      if(status == 0) {
        let { vip2 } = data;
        let isVip = 1;// 默认1，最低级
        if(vip2) {
          let ifBefore = dayjs().isBefore(dayjs(vip2).add(1,'day'),'day');
          if(ifBefore) {
            isVip = 2;
          }
        }
        this.isVip  = isVip;
        window.localStorage.setItem("ISVIP", isVip);
      }
    },
  },
  mounted() {},
  created: function () {
    this.searchType = this.$route.query.searchType;
    this.keyword = this.$route.query.key;
    this.title_word = this.keyword;
    let isVip = window.localStorage.getItem('ISVIP');
    if(isVip) {
      this.isVip = Number(isVip);
    } else {
      this.getUserRole();
      this.handleGetVip();
    }
    if (this.searchType && this.searchType === "advanced") {
      if (typeof this.keyword === "object") {
        this.title_word = this.keyword.join(" ");
      } else {
        this.keyword = [this.keyword];
      }
    }
    this.normalSearch();
    this.getFilterOpt();
  },
};
</script>

<style scoped>
.baseResult {
  background: #f9f9f9;
  min-height: 700px;
  padding-bottom: 50px;
}
.baseResult .content {
  width: 1080px;
  margin: 0 auto;
}
.baseResult .content .el-card__header span {
  margin-left: 18px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  /* margin-top:4px; */
}
.baseResult .content .el-card__header button {
  padding: 10px 20px !important;
  border: 1px solid #409eff;
}
.baseResult .content .resultTtle {
  font-size: 14px;
  color: #333;
}
.baseResult .content .resultTtle .pointData {
  font-size: 12px;
  color: #eb7400;
  margin-bottom: 5px;
}
.baseResult .content .resultTtle .el-col {
  padding: 0;
}
.baseResult .content .resultTtle .num .el-col {
  padding: 0;
}
.baseResult .content .resultTtle span.sort_sp {
  line-height: 32px;
  margin-right: 10px;
  font-size: 13px;
  color: #606266;
}
.baseResult .content .resultTtle .el-select {
  width: 150px;
  line-height: 32px;
}
.baseResult .content .tags {
  margin-top: 20px;
}
.baseResult .content .tags em {
  font-size: 12px;
  color: #6098db;
}
.baseResult .content .tags span {
  margin-right: 10px;
}
.baseResult .content .tags .clearBtn {
  line-height: 32px;
}
.baseResult .content .tags .clearBtn img {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 10px;
  margin-top: 6px;
}
.baseResult .content .resultList {
  margin-top: 20px;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-bottom: none;
}
.baseResult .content .resultList .tags {
  margin-top: 10px;
}
.baseResult .content .resultList ul li {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.baseResult .content .resultList .listTitle .title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.baseResult .content .resultList .listTitle .title .pptIcon {
  width: 20px;
  vertical-align: middle;
}
.baseResult .content .resultList .listTitle .YXYZ span {
  /* line-height: 30px; */
  margin-left: 10px;
}
.baseResult .content .resultList .listTitle .RGBZ span {
  line-height: 30px;
  margin-left: 10px;
}
.baseResult .content .resultList .listTitle .YXYZ img {
  width: 15px;
  height: 15px;
  margin-top: 2px;
}
.baseResult .content .resultList .listTitle .RGBZ img {
  width: 17px;
  height: 20px;
  margin-top: 5px;
}
.baseResult .content .resultList .listInfo {
  margin-top: 10px;
}
.baseResult .content .resultList .listInfo .el-col {
  margin-bottom: 10px;
}
.baseResult .content .resultList .listInfo .el-col span {
  color: #387ed2;
}
.baseResult .content .resultList .listInfo .initHeight {
  height: 120px;
  overflow: hidden;
}
.baseResult .content .resultList .listInfo em.down {
  /* background:#387ed2;
        border:none;
        padding:5px 10px;
        color:#fff;
        border-radius: 10px; */
  margin-top: 5px;
  font-size: 24px;
  position: relative;
  top: -24px;
  right: -60px;
  cursor: pointer;
}
.baseResult .content .resultList .listInfo .autoHeight {
  height: auto;
}
.baseResult .content .resultList .listInfo .el-col .key_infor {
  margin-top: 10px;
  line-height: 25px;
}
.baseResult .content .resultList .listInfo .el-col .key_infor em{
  display: block;
}
.baseResult .content .resultList .action {
  width: 50px;
  height: 100%;
  border-left: 1px solid #ccc;
  position: absolute;
  top: 0;
  right: 0;
  background: #f5f5f5;
  /* padding-top: 26px; */
}
.baseResult .content .resultList .action a {
  display: block;
  height: 33.3%;
}
.baseResult .content .resultList .action a.translate {
  background: url("../assets/img/icon1.png") no-repeat center center;
}
.baseResult .content .resultList .action a.fullText {
  background: url("../assets/img/icon2.png") no-repeat center center;
}
.baseResult .content .resultList .action a.collection {
  background: url("../assets/img/icon3.png") no-repeat center center;
}
.baseResult .content .resultList .action a.collectionTrue {
  background: url("../assets/img/icon3_01.png") no-repeat center center;
}
.baseResult .content .resultList .action a.share {
  background: url("../assets/img/icon4.png") no-repeat center center;
}
.baseResult .content .resultList .action a:hover {
  background-color: #387ed2;
}
.baseResult .content .resultList .action a.translate:hover {
  background-image: url("../assets/img/icon1_01.png");
}
.baseResult .content .resultList .action a.fullText:hover {
  background-image: url("../assets/img/icon2_01.png");
}
.baseResult .content .resultList .action a.collection:hover {
  background-image: url("../assets/img/icon3_02.png");
}
.baseResult .content .resultList .action a.share:hover {
  background-image: url("../assets/img/icon4_01.png");
}
.baseResult .content .el-pagination {
  margin-top: 30px;
  text-align: center;
}
.baseResult .noData {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
}
.baseResult .noData img {
  display: block;
  margin: 0 auto;
}
.baseResult .noData span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}
/* .baseResult .content .resultList .action a img{
  width: 18px;
  height: 18px;
  display: block;
  margin: 0 auto;
}
.baseResult .content .resultList .action a img.fullText{
  width: 20px;
} */
</style>


// WEBPACK FOOTER //
// src/views/baseResult.vue